export const strings = [
  {
    label: "Harmonieharfe 25 Saiten",
    reverse: false,
    key: "harmonieharfe25saiten",
    strings: [
      { note: "G1", freq: 196.0 },
      { note: "G#2", freq: 207.65 },
      { note: "A3", freq: 220.0 },
      { note: "A#4", freq: 233.08 },
      { note: "B5", freq: 246.94 },
      { note: "C6", freq: 261.63 },
      { note: "C#7", freq: 277.18 },
      { note: "D8", freq: 293.66 },
      { note: "D#9", freq: 311.13 },
      { note: "E10", freq: 329.63 },
      { note: "F11", freq: 349.23 },
      { note: "F#12", freq: 369.99 },
      { note: "G13", freq: 392.0 },
      { note: "G#14", freq: 415.3 },
      { note: "A15", freq: 440.0 },
      { note: "A#16", freq: 466.16 },
      { note: "B17", freq: 493.88 },
      { note: "C18", freq: 523.25 },
      { note: "C#19", freq: 554.37 },
      { note: "D20", freq: 587.33 },
      { note: "D#21", freq: 622.25 },
      { note: "E22", freq: 659.26 },
      { note: "F23", freq: 698.46 },
      { note: "F#24", freq: 739.99 },
      { note: "G25", freq: 783.99 },
    ],
  },
  {
    label: "Veeh-Harfe 25 Saiten",
    reverse: false,
    key: "veehharfe25saiten",
    strings: [
      { note: "G1", freq: 196.0 },
      { note: "G#2", freq: 207.65 },
      { note: "A3", freq: 220.0 },
      { note: "Bb4", freq: 233.08 },
      { note: "B5", freq: 246.94 },
      { note: "C6", freq: 261.63 },
      { note: "C#7", freq: 277.18 },
      { note: "D8", freq: 293.66 },
      { note: "Eb9", freq: 311.13 },
      { note: "E10", freq: 329.63 },
      { note: "F11", freq: 349.23 },
      { note: "F#12", freq: 369.99 },
      { note: "G13", freq: 392.0 },
      { note: "G#14", freq: 415.3 },
      { note: "A15", freq: 440.0 },
      { note: "Bb16", freq: 466.16 },
      { note: "B17", freq: 493.88 },
      { note: "C18", freq: 523.25 },
      { note: "C#19", freq: 554.37 },
      { note: "D20", freq: 587.33 },
      { note: "Eb21", freq: 622.25 },
      { note: "E22", freq: 659.26 },
      { note: "F23", freq: 698.46 },
      { note: "F#24", freq: 739.99 },
      { note: "G25", freq: 783.99 },
    ],
  },
  {
    label: "Veeh Harfe 18 Saiten",
    reverse: false,
    key: "veehharfe18saiten",
    strings: [
      { note: "B1", freq: 246.94 },
      { note: "C2", freq: 261.63 },
      { note: "C#3", freq: 277.18 },
      { note: "D4", freq: 293.66 },
      { note: "Eb5", freq: 311.13 },
      { note: "E6", freq: 329.63 },
      { note: "F7", freq: 349.23 },
      { note: "F#8", freq: 369.99 },
      { note: "G9", freq: 392.0 },
      { note: "G#10", freq: 415.3 },
      { note: "A11", freq: 440.0 },
      { note: "Bb12", freq: 466.16 },
      { note: "B13", freq: 493.88 },
      { note: "C14", freq: 523.25 },
      { note: "C#15", freq: 554.37 },
      { note: "D16", freq: 587.33 },
      { note: "Eb17", freq: 622.25 },
      { note: "E18", freq: 659.26 },
    ],
  },
  {
    label: "Veeh-Harfe 37 Saiten",
    reverse: false,
    key: "veehharfe37saiten",
    strings: [
      { note: "G1", freq: 98.0 },
      { note: "G#2", freq: 103.83 },
      { note: "A3", freq: 110.0 },
      { note: "Bb4", freq: 116.54 },
      { note: "B5", freq: 123.47 },
      { note: "C6", freq: 130.81 },
      { note: "C#7", freq: 138.59 },
      { note: "D8", freq: 146.83 },
      { note: "Eb9", freq: 155.56 },
      { note: "E10", freq: 164.81 },
      { note: "F11", freq: 174.61 },
      { note: "F#12", freq: 185.0 },
      { note: "G13", freq: 196.0 },
      { note: "G#14", freq: 207.65 },
      { note: "A15", freq: 220.0 },
      { note: "Bb16", freq: 233.08 },
      { note: "B17", freq: 246.94 },
      { note: "C18", freq: 261.63 },
      { note: "C#19", freq: 277.18 },
      { note: "D20", freq: 293.66 },
      { note: "Eb21", freq: 311.13 },
      { note: "E22", freq: 329.63 },
      { note: "F23", freq: 349.23 },
      { note: "F#24", freq: 369.99 },
      { note: "G25", freq: 392.0 },
      { note: "G#26", freq: 415.3 },
      { note: "A27", freq: 440.0 },
      { note: "Bb28", freq: 466.16 },
      { note: "B29", freq: 493.88 },
      { note: "C30", freq: 523.25 },
      { note: "C#31", freq: 554.37 },
      { note: "D32", freq: 587.33 },
      { note: "Eb33", freq: 622.25 },
      { note: "E34", freq: 659.26 },
      { note: "F35", freq: 698.46 },
      { note: "F#36", freq: 739.99 },
      { note: "G37", freq: 783.99 },
    ],
  },
  {
    label: "Zauberharfe 25 Saiten (Sopran/Alt)",
    reverse: true,
    key: "zauberharfe25saitenSopranAlt",
    strings: [
      { note: "G1", freq: 196.0 },
      { note: "Gis2", freq: 207.65 },
      { note: "A3", freq: 220.0 },
      { note: "B4", freq: 233.08 },
      { note: "H5", freq: 246.94 },
      { note: "C6", freq: 261.63 },
      { note: "Cis7", freq: 277.18 },
      { note: "D8", freq: 293.66 },
      { note: "Es9", freq: 311.13 },
      { note: "E10", freq: 329.63 },
      { note: "F11", freq: 349.23 },
      { note: "Fis12", freq: 369.99 },
      { note: "G13", freq: 392.0 },
      { note: "Gis14", freq: 415.3 },
      { note: "A15", freq: 440.0 },
      { note: "B16", freq: 466.16 },
      { note: "H17", freq: 493.88 },
      { note: "C18", freq: 523.25 },
      { note: "Cis19", freq: 554.37 },
      { note: "D20", freq: 587.33 },
      { note: "Es21", freq: 622.25 },
      { note: "E22", freq: 659.26 },
      { note: "F23", freq: 698.46 },
      { note: "Fis24", freq: 739.99 },
      { note: "G25", freq: 783.99 },
    ],
  },
  {
    label: "Zauberharfe 25 Saiten (Bass)",
    reverse: true,
    key: "zauberharfe25saitenBass",
    strings: [
      { note: "G1", freq: 98.0 },
      { note: "Gis2", freq: 103.83 },
      { note: "A3", freq: 110.0 },
      { note: "B4", freq: 116.54 },
      { note: "H5", freq: 123.47 },
      { note: "C6", freq: 130.81 },
      { note: "Cis7", freq: 138.59 },
      { note: "D8", freq: 146.83 },
      { note: "Es9", freq: 155.56 },
      { note: "E10", freq: 164.81 },
      { note: "F11", freq: 174.61 },
      { note: "Fis12", freq: 185.0 },
      { note: "G13", freq: 196.0 },
      { note: "Gis14", freq: 207.65 },
      { note: "A15", freq: 220.0 },
      { note: "B16", freq: 233.08 },
      { note: "H17", freq: 246.94 },
      { note: "C18", freq: 261.63 },
      { note: "Cis19", freq: 277.18 },
      { note: "D20", freq: 293.66 },
      { note: "Es21", freq: 311.13 },
      { note: "E22", freq: 329.63 },
      { note: "F23", freq: 349.23 },
      { note: "Fis24", freq: 369.99 },
      { note: "G25", freq: 392.0 },
    ],
  },
  {
    label: "Zauberharfe 21 Saiten (Sopran/Alt)",
    reverse: true,
    key: "zauberharfe21saitenSopranAlt",
    strings: [
      { note: "A1", freq: 220.0 },
      { note: "B2", freq: 233.08 },
      { note: "H3", freq: 246.94 },
      { note: "C4", freq: 261.63 },
      { note: "Cis5", freq: 277.18 },
      { note: "D6", freq: 293.66 },
      { note: "Es7", freq: 311.13 },
      { note: "E8", freq: 329.63 },
      { note: "F9", freq: 349.23 },
      { note: "Fis10", freq: 369.99 },
      { note: "G11", freq: 392.0 },
      { note: "Gis12", freq: 415.3 },
      { note: "A13", freq: 440.0 },
      { note: "B14", freq: 466.16 },
      { note: "H15", freq: 493.88 },
      { note: "C16", freq: 523.25 },
      { note: "Cis17", freq: 554.37 },
      { note: "D18", freq: 587.33 },
      { note: "Es19", freq: 622.25 },
      { note: "E20", freq: 659.26 },
      { note: "F21", freq: 698.46 },
    ],
  },
  {
    label: "Akkordzither 25 Saiten / 6 Akkorde à 4 Saiten",
    reverse: false,
    key: "akkordzither25saiten",
    strings: [
      { note: "E1-Edur", freq: 329.63 },
      { note: "B2-Edur", freq: 246.94 },
      { note: "G3-Edur", freq: 207.65 },
      { note: "E4-Edur", freq: 82.41 },

      { note: "E1-Adur", freq: 329.63 },
      { note: "A2-Adur", freq: 220.0 },
      { note: "C#3-Adur", freq: 277.18 },
      { note: "A4-Adur", freq: 110.0 },

      { note: "D1-Ddur", freq: 293.66 },
      { note: "A2-Ddur", freq: 220.0 },
      { note: "F3-Ddur", freq: 185.0 },
      { note: "D4-Ddur", freq: 146.83 },

      { note: "D1-Gdur", freq: 293.66 },
      { note: "B2-Gdur", freq: 246.94 },
      { note: "G3-Gdur", freq: 196.0 },
      { note: "G4-Gdur", freq: 98.0 },

      { note: "E1-Cdur", freq: 329.63 },
      { note: "C2-Cdur", freq: 261.63 },
      { note: "G3-Cdur", freq: 196.0 },
      { note: "C4-Cdur", freq: 130.81 },

      { note: "F4-Fdur", freq: 349.23 },
      { note: "C4-Fdur", freq: 261.63 },
      { note: "A4-Fdur", freq: 220.0 },
      { note: "F4-Fdur", freq: 87.31 },

      { note: "C1", freq: 261.63 },
      { note: "C#2", freq: 277.18 },
      { note: "D3", freq: 293.66 },
      { note: "D#4", freq: 311.13 },
      { note: "E5", freq: 329.63 },
      { note: "F6", freq: 349.23 },
      { note: "F#7", freq: 369.99 },
      { note: "G8", freq: 392.0 },
      { note: "G#9", freq: 415.3 },
      { note: "A10", freq: 440.0 },
      { note: "A#11", freq: 466.16 },
      { note: "B12", freq: 493.88 },
      { note: "C13", freq: 523.25 },
      { note: "C#14", freq: 554.37 },
      { note: "D15", freq: 587.33 },
      { note: "D#16", freq: 622.25 },
      { note: "E17", freq: 659.26 },
      { note: "F18", freq: 698.46 },
      { note: "F#19", freq: 739.99 },
      { note: "G20", freq: 783.99 },
      { note: "G#21", freq: 830.61 },
      { note: "A22", freq: 880.0 },
      { note: "A#23", freq: 932.33 },
      { note: "B24", freq: 987.77 },
      { note: "C25", freq: 1046.5 },
    ],
  },
  {
    label: "Wantaluga Harfe 37 Saiten",
    reverse: false,
    key: "wantaluga37saiten",
    strings: [
      { note: "G1", freq: 98.0 },
      { note: "G#2", freq: 103.83 },
      { note: "A3", freq: 110.0 },
      { note: "Bb4", freq: 116.54 },
      { note: "B5", freq: 123.47 },
      { note: "C6", freq: 130.81 },
      { note: "C#7", freq: 138.59 },
      { note: "D8", freq: 146.83 },
      { note: "Eb9", freq: 155.56 },
      { note: "E10", freq: 164.81 },
      { note: "F11", freq: 174.61 },
      { note: "F#12", freq: 185.0 },
      { note: "G13", freq: 196.0 },
      { note: "G#14", freq: 207.65 },
      { note: "A15", freq: 220.0 },
      { note: "Bb16", freq: 233.08 },
      { note: "B17", freq: 246.94 },
      { note: "C18", freq: 261.63 },
      { note: "C#19", freq: 277.18 },
      { note: "D20", freq: 293.66 },
      { note: "Eb21", freq: 311.13 },
      { note: "E22", freq: 329.63 },
      { note: "F23", freq: 349.23 },
      { note: "F#24", freq: 369.99 },
      { note: "G25", freq: 392.0 },
      { note: "G#26", freq: 415.3 },
      { note: "A27", freq: 440.0 },
      { note: "Bb28", freq: 466.16 },
      { note: "B29", freq: 493.88 },
      { note: "C30", freq: 523.25 },
      { note: "C#31", freq: 554.37 },
      { note: "D32", freq: 587.33 },
      { note: "Eb33", freq: 622.25 },
      { note: "E34", freq: 659.26 },
      { note: "F35", freq: 698.46 },
      { note: "F#36", freq: 739.99 },
      { note: "G37", freq: 783.99 },
    ],
  },
];
